import { ActionType, PayloadErrorType } from '../../types/reduxTypes';
import {
  CLEAR_RESTORE_DATA,
  HANDLE_RESTORE_ROUTE,
  HANDLE_RESTORE_ROUTE_FAILED,
  HANDLE_RESTORE_ROUTE_SUCCESS,
  RESTORE_ACCOUNT_EMAIL,
  RESTORE_ACCOUNT_EMAIL_FAILED,
  RESTORE_ACCOUNT_EMAIL_SUCCESS,
  RESTORE_ACCOUNT_PASSWORD,
  RESTORE_ACCOUNT_PASSWORD_FAILED,
  RESTORE_ACCOUNT_PASSWORD_SUCCESS,
} from '../constants';
import { RestoreAccountMetaDataType } from '../../types/stateTypes';

export type RestoreAccountPasswordType = RestoreAccountMetaDataType & {
  password: string;
};

export function clearRestoreData(): ActionType {
  return {
    payload: null,
    type: CLEAR_RESTORE_DATA,
  };
}
export function handleRestoreRoute(payload: string): ActionType<string> {
  return {
    payload,
    type: HANDLE_RESTORE_ROUTE,
  };
}

export function handleRestoreRouteFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: HANDLE_RESTORE_ROUTE_FAILED,
  };
}
export function handleRestoreRouteSuccess(payload: RestoreAccountMetaDataType): ActionType {
  return {
    payload,
    type: HANDLE_RESTORE_ROUTE_SUCCESS,
  };
}
export function restoreAccountEmail(payload: string): ActionType<string> {
  return {
    payload,
    type: RESTORE_ACCOUNT_EMAIL,
  };
}
export function restoreAccountEmailFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: RESTORE_ACCOUNT_EMAIL_FAILED,
  };
}
export function restoreAccountEmailSuccess(): ActionType {
  return {
    payload: null,
    type: RESTORE_ACCOUNT_EMAIL_SUCCESS,
  };
}
export function restoreAccountPassword(payload: RestoreAccountPasswordType): ActionType {
  return {
    payload,
    type: RESTORE_ACCOUNT_PASSWORD,
  };
}
export function restoreAccountPasswordFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: RESTORE_ACCOUNT_PASSWORD_FAILED,
  };
}
export function restoreAccountPasswordSuccess(): ActionType {
  return {
    payload: null,
    type: RESTORE_ACCOUNT_PASSWORD_SUCCESS,
  };
}
